import { render, staticRenderFns } from "./SendInvitationModal.vue?vue&type=template&id=d2b50f70"
import script from "./SendInvitationModal.vue?vue&type=script&lang=js"
export * from "./SendInvitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports